import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormattedMessage, injectIntl } from 'react-intl';

import { COMMON } from '../../../../constants/strings';
import Button from '../../../Button';
import { CommunityCard } from '../CommunityCard';
import { TimeShow } from '../../../common/TimeShow';
import { IDS } from '../../../../constants/ids';
import styl from './index.styl';

const InviteListItem = ({
  logo,
  name,
  userName,
  subtitle,
  onClick,
  createdAt,
  handleAccept,
  handleDecline,
  organizations,
  intl: { formatMessage },
  id,
  invitationId,
  communityId,
  role,
  disabled,
}) => {
  const subtitleContent = useMemo(() => {
    if (!role) return null;

    return () => <span>{role}</span>;
  }, [role]);

  return (
    <CommunityCard
      avatar={{
        src: logo,
        size: 100,
        name,
      }}
      renderTitle={() => (
        <div className="pointer" onClick={() => onClick(id, 'profile')}>
          {name} <span className="fw4 g-color--accent">{userName}</span>
        </div>
      )}
      renderSubTitle={subtitleContent}
      renderContent={() => (
        <FormattedMessage
          id="community.activity.invite"
          values={{
            communityName: (
              <span
                onClick={() => onClick(communityId, 'community')}
                className="g-color--info fw6 pointer"
              >
                {subtitle}
              </span>
            ),
          }}
        />
      )}
      renderSubContent={() => (
        <FormattedMessage
          id="community.activity.fromOrganization"
          values={{
            organization: organizations,
          }}
        />
      )}
      renderInfo={() => <TimeShow timestamp={createdAt} />}
      renderActions={() => (
        <Fragment>
          <Button
            id={IDS.ACTIVITIES.INVITATION_ACCEPT_BTN}
            disabled={disabled}
            color="primary"
            className="mb1"
            onClick={() => handleAccept(invitationId)}
          >
            {formatMessage(COMMON.accept)}
          </Button>
          <Button
            id={IDS.ACTIVITIES.INVITATION_DECLINE_BTN}
            disabled={disabled}
            color="accent"
            onClick={() => handleDecline(invitationId)}
          >
            {formatMessage(COMMON.decline)}
          </Button>
        </Fragment>
      )}
    />
  );
};

InviteListItem.propTypes = {
  createdAt: PropTypes.string,
  logo: PropTypes.string,
  name: PropTypes.string,
  userName: PropTypes.string,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  handleDecline: PropTypes.func,
  handleAccept: PropTypes.func,
  organizations: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  id: PropTypes.number.isRequired,
  communityId: PropTypes.number,
  invitationId: PropTypes.number,
  role: PropTypes.string,
  disabled: PropTypes.bool,
};

InviteListItem.defaultProps = {
  createdAt: '',
  logo: '',
  name: '',
  userName: '',
  subtitle: '',
  onClick: null,
  handleDecline: null,
  handleAccept: null,
  organizations: '',
  invitationId: null,
  communityId: null,
  role: '',
  disabled: null,
};

export default injectIntl(
  CSSModules(InviteListItem, styl, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Communities/Components/ActivitiesList/InviteListItem.jsx